module.exports = __webpack_public_path__ + "static/img/duoyongtu.ac59429.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productlist/duoyongtu.jpg
// module id = +WKM
// module chunks = 1